import { Component, Input } from '@angular/core';
import { Credit } from '../../../models/credit';

@Component({
  selector: 'app-mon-panier',
  templateUrl: './mon-panier.component.html',
  styleUrls: ['./mon-panier.component.scss'],
})
export class MonPanierComponent {
  @Input() commande!: Credit.Commande;
}
